export class YesNoFieldParameter {
  yesLabel: string | undefined;
  noLabel: string | undefined;
}
